/**
 * A utility function that combines multiple class names, handling conditional classes and filtering out falsy values.
 * @param classes - Array of classes, objects with conditional classes, or falsy values
 * @returns A string of concatenated class names
 */
export function classNames(...classes: (string | boolean | null | undefined | Record<string, boolean>)[]): string {
  const result: string[] = [];

  classes.forEach((item) => {
    if (!item) return;
    
    if (typeof item === 'string') {
      result.push(item);
    } else if (typeof item === 'object') {
      Object.entries(item).forEach(([className, condition]) => {
        if (condition) {
          result.push(className);
        }
      });
    }
  });

  return result.join(' ');
}

// Named export for better compatibility
export const cn = classNames;